import { render, staticRenderFns } from "./TableStatus.vue?vue&type=template&id=50f27378"
import script from "./TableStatus.vue?vue&type=script&lang=js"
export * from "./TableStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports